import LazyloadWrapper from './LazyloadWrapper';

export default LazyloadWrapper;
